
import React, { useState, useRef } from "react";
import {
  Smartphone,
  Apple,
} from "lucide-react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  Collapse,
  Box,
  Container,
  useMediaQuery,
  Avatar,
  CircularProgress,
  MenuList,
  Menu as Menumui,
  MenuItem,
} from "@mui/material";
import {
  Home,
  Tv,
  Trophy,
  ShieldCheck,
  Mail,
  Sun,
  Newspaper,
  Moon,
  Menu,
  ChevronDown,
  ChevronRight,
  FileText,
} from "lucide-react";
import { useThemeContext } from "../context/ThemeContext";
import apiClient from "../utils/apiClient";
import { useEffect } from "react";
import { Globe } from "lucide-react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";


export default function Header() {
  const dropdownRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch()
  const selectedCountry = useSelector((state) => state.countrie) || {};
  const webSiteData = useSelector((state) => state.website) || {};
  const tournaments = useSelector((state) => state.tournaments) || [];
  console.log(webSiteData, 'ooo')

  const navItems = [
    {
      label: "Home",
      icon: <Home size={18} />,
      link: "/",
    },

    {
      label: webSiteData?.sportName || "Sports",
      icon: <Tv size={18} />,
      link: "/channels",
    },

    {
      label: "Tournaments",
      icon: <Trophy size={18} />,
      dropdown: [
        {
          title: "Football",
          subItems: [
            ...tournaments
          ],
        },

        // {
        //   title: "Cricket ( Coming soon )",
        //   subItems: []
        // },
      ],
    },

    // {
    //   label: "DMCA",
    //   icon: <ShieldCheck size={18} />,
    //   link: "/dmca",
    // },

    // {
    //   label: "Contact Us",
    //   icon: <Mail size={18} />,
    //   link: "/contact",
    // },

    {
      label: "News",
      icon: <Newspaper size={18} />,
      link: "/newses",
    },
  ];

  console.log(selectedCountry, 'ooo')
  const mobile = useMediaQuery("(max-width:900px)");

  const { mode, toggleTheme } = useThemeContext();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [openSubMenu, setOpenSubMenu] = useState(null);

  const [countries, setCountries] = useState([]);

  const [loadingCountries, setLoadingCountries] = useState(false);
  const [loadingTournaments, setLoadingTournaments] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // =========================
  // FETCH COUNTRIES
  // =========================

  const getCountries = async () => {
    try {
      setLoadingCountries(true);

      const response = await apiClient.get('/public/get_countries')
      const result = await response?.data;

      if (result?.success) {
        setCountries(result.data);
        const savedCountry = localStorage.getItem("selectedCountry");
        if (savedCountry) {
          const parsedCountry = JSON.parse(savedCountry);

          dispatch({
            key: "countrie",
            value: parsedCountry,
            type: "SET_VALUE",
          });

        } else if (result.data.length > 0) {
          get_tournaments('first')
          // dispatch({
          //   key: "countrie",
          //   value: result.data[0],
          //   type: "SET_VALUE",
          // });
          // localStorage.setItem(
          //   "selectedCountry",
          //   JSON.stringify(result.data[0])
          // );
        }
      }

    } catch (error) {
      console.log("Country API Error:", error);
    } finally {
      setLoadingCountries(false);
    }
  };

  const get_tournaments = async (data = '') => {
    try {
      setLoadingTournaments(true);

      const response = await apiClient.get('/public/get_tournaments/' + data)
      const result = await response?.data;

      if (result?.success) {
        if (result.data.length > 0) {
          dispatch({
            key: "tournaments",
            value: result.data,
            type: "SET_VALUE",
          });
        }
      }

    } catch (error) {
      console.log("Country API Error:", error);
    } finally {
      setLoadingTournaments(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpenDropdown(null);
        setOpenSubMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };
  }, []);

  useEffect(() => {
    if (selectedCountry?.country_id) {
      get_tournaments(selectedCountry?.country_id)
    }
  }, [selectedCountry?.country_id])

  useEffect(() => {
    getCountries();
  }, []);

  useEffect(() => {
    const savedCountry = localStorage.getItem("selectedCountry");

    if (savedCountry) {
      dispatch({
        key: "countrie",
        value: JSON.parse(savedCountry),
        type: "SET_VALUE",
      });
    }
  }, []);

  const handleSelectCountry = async (country) => {
    dispatch({ key: 'countrie', value: country, type: 'SET_VALUE' })

    localStorage.setItem(
      "selectedCountry",
      JSON.stringify(country)
    );

    setAnchorEl(null);

  };

  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  const toggleSubmenu = (key) => {
    setOpenSubMenu(openSubMenu === key ? null : key);
  };

  return (
    <>
      <AppBar
        position="sticky"
        top={0}
        elevation={0}
        className="!bg-white dark:!bg-[#121212] border-b border-gray-200 dark:border-gray-800 transition-all duration-300"
      >
        <Container maxWidth="xl">
          <Toolbar className="flex justify-between py-2">
            {/* LOGO */}
            <Link to="/">
              <Box className="flex items-center gap-3">
                <img
                  src="https://footplayhd.com/logo.png"
                  alt="logo"
                  className="w-10 h-10"
                />

                <div>
                  <h2 className="text-[16px] font-extrabold text-purple-600 leading-none">
                    FootPlayHD.com
                  </h2>

                  {/* <p className="text-[10px] tracking-[2px] text-gray-600 dark:text-gray-400 uppercase">
                  Anytime, Anywhere
                </p> */}
                </div>
              </Box>
            </Link>
            {/* DESKTOP MENU */}
            {!mobile && (
              <div className="flex items-center gap-2">
                {navItems.map((item, index) => (
                  <div
                    key={index}
                    className="relative"
                    ref={item.dropdown ? dropdownRef : null}
                  >
                    {!item.dropdown ? (
                      <Link
                        to={item.link}
                        className={`flex items-center gap-2 px-4 py-3 rounded-xl text-[15px] font-medium transition-all duration-300
                        
                        ${location.pathname === item.link

                            ? "bg-[#4b4b4b] text-white"
                            : "text-gray-800 dark:text-white hover:bg-gray-100 dark:hover:bg-[#1f1f1f]"
                          }
                        `}
                      >
                        {item.icon}
                        {item.label}
                      </Link>
                    ) : (
                      <>
                        <button
                          onClick={() => toggleDropdown(index)}
                          className="flex items-center gap-2 px-4 py-3 rounded-xl text-[15px] font-medium text-gray-800 dark:text-white hover:bg-gray-100 dark:hover:bg-[#1f1f1f] transition-all duration-300"
                        >
                          {item.icon}

                          {item.label}

                          <ChevronDown size={16} />
                        </button>

                        {openDropdown === index && (
                          <div className="absolute top-[60px] left-0 w-[300px] bg-white dark:bg-[#1c1c1c] shadow-2xl rounded-xl overflow-hidden z-50 border border-gray-200 dark:border-gray-700">
                            {item.dropdown.map((drop, subIndex) => (
                              <div key={subIndex}>
                                {/* MAIN TITLE */}
                                {drop.subItems?.length > 0 && <>
                                  <button
                                    onClick={() =>
                                      toggleSubmenu(`${index}-${subIndex}`)
                                    }
                                    className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-100 dark:hover:bg-[#2a2a2a] border-b border-gray-200 dark:border-gray-700 transition-all"
                                  >
                                    <div className="font-semibold text-sm uppercase text-gray-800 dark:text-white">
                                      {drop.title.includes('Cricket') ? '🏏' : '⚽'} {drop.title}
                                    </div>
                                    {openSubMenu ===
                                      `${index}-${subIndex}` ? (
                                      <ChevronDown
                                        size={16}
                                        className="text-gray-700 dark:text-white"
                                      />
                                    ) : (
                                      <ChevronRight
                                        size={16}
                                        className="text-gray-700 dark:text-white"
                                      />
                                    )}
                                  </button>

                                  {/* SUB MENU */}
                                  <Collapse
                                    in={
                                      openSubMenu === `${index}-${subIndex}`
                                    }
                                  >
                                    <div className="bg-gray-50 dark:bg-[#151515]" style={{ maxHeight: '250px', overflow: 'auto' }}>
                                      {drop.subItems.map((sub, i) => (
                                        <Link
                                          key={i}
                                          to={'/tournament/' + sub.league_id}
                                          className="block px-10 py-4 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#242424] border-b border-gray-100 dark:border-gray-800"
                                        >
                                          {sub.league_name}
                                        </Link>
                                      ))}
                                    </div>
                                  </Collapse>
                                </>}

                                {drop.subItems?.length === 0 && <>
                                  <button
                                    onClick={() =>
                                      toggleSubmenu(`${index}-${subIndex}`)
                                    }
                                    className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-100 dark:hover:bg-[#2a2a2a] border-b border-gray-200 dark:border-gray-700 transition-all "
                                  >
                                    <div className="font-semibold text-sm uppercase text-gray-800 dark:text-white">
                                      {drop.title.includes('Cricket') ? '🏏' : '⚽'}  {drop.title}
                                    </div>
                                  </button>
                                </>
                                }
                              </div>
                            ))}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                ))}
                {(webSiteData?.androidAppLink ||
                  webSiteData?.iosAppLink) && (
                    < >

                      {/* ANDROID */}
                      {webSiteData?.androidAppLink && (
                        <a
                          href={
                            webSiteData?.androidAppLink
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-full transition-all duration-300 shadow-md  "
                        >
                          <Smartphone size={18} />

                          <span className="hidden md:block">
                            Android App
                          </span>
                        </a>
                      )}

                      {/* IOS */}
                      {webSiteData?.iosAppLink && (
                        <a
                          href={
                            webSiteData?.iosAppLink
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center gap-2 bg-black hover:bg-gray-900 text-white px-4 py-2 rounded-full transition-all duration-300 shadow-md border border-gray-700 "
                        >
                          <Apple size={18} />

                          <span className="hidden md:block">
                            iOS App
                          </span>
                        </a>
                      )}

                    </>
                  )}
                <button
                  onClick={(e) => setAnchorEl(e.currentTarget)}
                // className="flex items-center gap-2 px-3 py-2 rounded-xl bg-gray-100 dark:bg-[#1f1f1f] hover:bg-gray-200 dark:hover:bg-[#2a2a2a] transition-all"
                >
                  {selectedCountry?.country_logo ? (
                    <>
                      <Avatar
                        src={selectedCountry.country_logo}
                        alt={selectedCountry.country_name}
                        sx={{
                          width: 24,
                          height: 24,
                        }}
                      />

                      {/* <span className="text-sm font-medium text-black dark:text-white">
                        {selectedCountry.country_name}
                      </span> */}
                    </>
                  ) : (
                    <>
                      <Globe
                        size={18}
                        className="text-black dark:text-white"
                      />

                      {/* <span className="text-sm text-black dark:text-white">
                        Country
                      </span> */}
                    </>
                  )}
                </button>

                {/* DROPDOWN */}

                <Menumui
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => setAnchorEl(null)}
                  PaperProps={{
                    sx: {
                      width: 250,
                      maxHeight: 400,
                      borderRadius: "16px",
                      mt: 1,
                    },
                  }}
                >
                  {loadingCountries ? (
                    <div className="flex justify-center py-6">
                      <CircularProgress size={24} />
                    </div>
                  ) : (
                    <MenuList style={{ padding: '5px' }}>
                      {countries.map((country) => {
                        const isActive =
                          selectedCountry?.country_id === country.country_id;

                        return (
                          <MenuItem
                            key={country.country_id}
                            onClick={() =>
                              handleSelectCountry(country)
                            }
                            className={`!py-3 !rounded-xl !mb-1 transition-all ${isActive
                              ? '!bg-blue-100 !text-blue-600'
                              : '!bg-transparent'
                              }`}                          >
                            <div className="flex items-center gap-3">
                              <Avatar
                                src={country.country_logo}
                                alt={country.country_name}
                                sx={{
                                  width: 28,
                                  height: 28,
                                  border: isActive
                                    ? '2px solid #2563eb'
                                    : '2px solid transparent',
                                }}
                              />
                              <span>{country.country_name}</span>
                              {isActive && (
                                <span className="ml-auto text-sm font-semibold">
                                  ✓
                                </span>
                              )}
                            </div>
                          </MenuItem>
                        );
                      })}
                    </MenuList>
                  )}
                </Menumui>

                {/* THEME BUTTON */}
                <IconButton onClick={toggleTheme}>
                  {mode === "light" ? (
                    <Moon className="text-black dark:text-white" />
                  ) : (
                    <Sun className="text-yellow-400" />
                  )}
                </IconButton>
              </div>
            )}

            {/* MOBILE MENU */}
            {mobile && (
              <div className="flex items-center gap-2">
                <button
                  onClick={(e) => setAnchorEl(e.currentTarget)}
                // className="flex items-center gap-2 px-3 py-2 rounded-xl bg-gray-100 dark:bg-[#1f1f1f] hover:bg-gray-200 dark:hover:bg-[#2a2a2a] transition-all"
                >
                  {selectedCountry?.country_logo ? (
                    <>
                      <Avatar
                        src={selectedCountry.country_logo}
                        alt={selectedCountry.country_name}
                        sx={{
                          width: 24,
                          height: 24,
                        }}
                      />

                      {/* <span className="text-sm font-medium text-black dark:text-white">
                        {selectedCountry.country_name}
                      </span> */}
                    </>
                  ) : (
                    <>
                      <Globe
                        size={18}
                        className="text-black dark:text-white"
                      />

                      {/* <span className="text-sm text-black dark:text-white">
                        Country
                      </span> */}
                    </>
                  )}
                </button>

                {/* DROPDOWN */}

                <Menumui
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => setAnchorEl(null)}
                  PaperProps={{
                    sx: {
                      width: 250,
                      maxHeight: 400,
                      borderRadius: "16px",
                      mt: 1,
                    },
                  }}
                >
                  {loadingCountries ? (
                    <div className="flex justify-center py-6">
                      <CircularProgress size={24} />
                    </div>
                  ) : (
                    <MenuList style={{ padding: '5px' }}>
                      {countries.map((country) => {
                        const isActive =
                          selectedCountry?.country_id === country.country_id;

                        return (
                          <MenuItem
                            key={country.country_id}
                            onClick={() =>
                              handleSelectCountry(country)
                            }
                            className={`!py-3 !rounded-xl !mb-1 transition-all ${isActive
                              ? '!bg-blue-100 !text-blue-600'
                              : '!bg-transparent'
                              }`}
                          >
                            <div className="flex items-center gap-3">
                              <Avatar
                                src={country.country_logo}
                                alt={country.country_name}
                                sx={{
                                  width: 28,
                                  height: 28,
                                  border: isActive
                                    ? '2px solid #2563eb'
                                    : '2px solid transparent',

                                }}
                              />
                              <span>{country.country_name}</span>
                              {isActive && (
                                <span className="ml-auto text-sm font-semibold">
                                  ✓
                                </span>
                              )}
                            </div>
                          </MenuItem>
                        )
                      })}
                    </MenuList>
                  )}
                </Menumui>

                <IconButton onClick={toggleTheme}>
                  {mode === "light" ? (
                    <Moon className="text-black dark:text-white" />
                  ) : (
                    <Sun className="text-yellow-400" />
                  )}
                </IconButton>

                <IconButton onClick={() => setMobileOpen(true)}>
                  <Menu className="text-black dark:text-white" />
                </IconButton>
              </div>
            )}
          </Toolbar>
        </Container>
      </AppBar>

      {/* MOBILE DRAWER */}
      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
      >
        <div className="w-[300px] h-full bg-white dark:bg-[#121212]">
          <div className="p-5 border-b border-gray-200 dark:border-gray-700">
            <h2 className="text-2xl font-bold text-purple-600">
              FootPlayHD.com
            </h2>
          </div>

          <div className="p-3">
            {navItems.map((item, index) => (
              <div key={index}>
                {!item.dropdown ? (
                  <Link
                    to={item.link}
                    className="flex items-center gap-3 px-4 py-4 rounded-lg text-gray-800 dark:text-white hover:bg-gray-100 dark:hover:bg-[#1f1f1f]"
                  >
                    {item.icon}
                    {item.label}
                  </Link>
                ) : (
                  <>
                    <button
                      onClick={() => toggleDropdown(index)}
                      className="w-full flex items-center justify-between px-4 py-4 rounded-lg text-gray-800 dark:text-white hover:bg-gray-100 dark:hover:bg-[#1f1f1f]"
                    >
                      <div className="flex items-center gap-3">
                        {item.icon}
                        {item.label}
                      </div>

                      {openDropdown === index ? (
                        <ChevronDown size={18} />
                      ) : (
                        <ChevronRight size={18} />
                      )}
                    </button>

                    <Collapse in={openDropdown === index}>
                      <div className="pl-4">
                        {item.dropdown.map((drop, subIndex) => (
                          <div key={subIndex}>
                            {drop.subItems?.length > 0 && <>
                              <button
                                onClick={() =>
                                  toggleSubmenu(`${index}-${subIndex}`)
                                }
                                className="w-full flex justify-between px-4 py-3 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#1f1f1f] rounded-lg"
                              >
                                {drop.title}

                                {openSubMenu ===
                                  `${index}-${subIndex}` ? (
                                  <ChevronDown size={16} />
                                ) : (
                                  <ChevronRight size={16} />
                                )}
                              </button>
                              <Collapse
                                in={
                                  openSubMenu === `${index}-${subIndex}`
                                }
                              >
                                <div className="pl-4" style={{ maxHeight: '250px', overflow: 'auto' }}>
                                  {drop.subItems.map((sub, i) => (
                                    <Link
                                      key={i}
                                      to={'/tournament/' + sub.league_id}
                                      className="block px-4 py-3 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#1f1f1f] rounded-lg"
                                    >
                                      {sub.league_name}
                                    </Link>
                                  ))}
                                </div>
                              </Collapse>
                            </>}
                            {drop.subItems?.length === 0 && <>
                              <button
                                onClick={() =>
                                  toggleSubmenu(`${index}-${subIndex}`)
                                }
                                className="w-full flex justify-between px-4 py-3 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#1f1f1f] rounded-lg"
                              >
                                {drop.title}
                              </button>
                            </>}

                          </div>
                        ))}
                      </div>
                    </Collapse>
                  </>
                )}
              </div>
            ))}
            {(webSiteData?.androidAppLink ||
              webSiteData?.iosAppLink) && (
                < >

                  {/* ANDROID */}
                  {webSiteData?.androidAppLink && (
                    <a
                      href={
                        webSiteData?.androidAppLink
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-full transition-all duration-300 shadow-md   my-4"
                    >
                      <Smartphone size={18} />

                      <span className="hidden md:block">
                        Android App
                      </span>
                    </a>
                  )}

                  {/* IOS */}
                  {webSiteData?.iosAppLink && (
                    <a
                      href={
                        webSiteData?.iosAppLink
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 bg-black hover:bg-gray-900 text-white px-4 py-2 rounded-full transition-all duration-300 shadow-md border border-gray-700  "
                    >
                      <Apple size={18} />

                      <span className="hidden md:block">
                        iOS App
                      </span>
                    </a>
                  )}

                </>
              )}
          </div>
        </div>
      </Drawer>
    </>
  );
}